import { GroupType } from '@app/origami-api/constants';
import { UserGroupServiceOptions } from '@app/origami-api/services/user-group.service';

export function getGroupTypes(
  cfg: UserGroupServiceOptions.GetSiteGroupsConfig,
  options?: { optionalGroupTypes?: GroupType[]; isETMFEnabled?: boolean },
): GroupType[] {
  const optionalGroupTypes = options && options.optionalGroupTypes ? options.optionalGroupTypes : [];
  const groupTypes: GroupType[] = [...optionalGroupTypes];

  if (cfg.includeStudyStartupTeamGroups === undefined) {
    cfg.includeStudyStartupTeamGroups = false;
  }

  if (cfg.includeStudyStartupTeamRoomGroups === undefined) {
    cfg.includeStudyStartupTeamGroups = false;
  }
  //cfg.includeStudyStartupTeamGroups = options && options.isETMFEnabled && cfg.includeStudyStartupTeamGroups;

  if (cfg.includeSecurityGroups === undefined) {
    cfg.includeSecurityGroups = true;
  }

  if (!groupTypes || !groupTypes.length) {
    if (cfg.includeAclGroups || cfg.includeAllGroups) {
      groupTypes.push(GroupType.ACL);
    }
    if (cfg.includeSecurityGroups || cfg.includeAllGroups) {
      groupTypes.push(GroupType.Security);
    }
    if (cfg.includeSmGroups || cfg.includeAllGroups) {
      groupTypes.push(GroupType.SM);
    }
    if (cfg.includeWorkflowGroups || cfg.includeAllGroups) {
      groupTypes.push(GroupType.Workflow);
    }
    if (cfg.includeInvestigativeSiteGroups || cfg.includeAllGroups) {
      groupTypes.push(GroupType.InvestigativeSite);
    }
    if (cfg.includeContactGroups || cfg.includeAllGroups) {
      groupTypes.push(GroupType.Contact);
    }
    if (cfg.includeSponsorGroups || cfg.includeAllGroups) {
      groupTypes.push(GroupType.Sponsor);
    }
    if (cfg.includeInvestigativeSiteInDataRoomGroups || cfg.includeAllGroups) {
      groupTypes.push(GroupType.InvestigativeSiteInDataRoom);
    }
    if (cfg.includeStudyStartupTeamGroups || cfg.includeAllGroups) {
      groupTypes.push(GroupType.StudyStartupTeam);
    }
    if (cfg.includeStudyStartupTeamRoomGroups || cfg.includeAllGroups) {
      groupTypes.push(GroupType.StudyStartupTeamRoom);
    }
    if (cfg.includeISReaders || cfg.includeAllGroups) {
      groupTypes.push(GroupType.ISReaders);
    }
    if (cfg.includeStartupSpecialists || cfg.includeAllGroups) {
      groupTypes.push(GroupType.StartupSpecialists);
    }
    if (cfg.includeISEditors || cfg.includeAllGroups) {
      groupTypes.push(GroupType.ISEditors);
    }
    if (cfg.includeCountryReaders || cfg.includeAllGroups) {
      groupTypes.push(GroupType.CountryReaders);
    }
    if (cfg.includeCountryEditors || cfg.includeAllGroups) {
      groupTypes.push(GroupType.CountryEditors);
    }
    if (cfg.includeUserLookup || cfg.includeAllGroups) {
      groupTypes.push(GroupType.UserLookup);
    }
    if (cfg.includeIndexManager || cfg.includeAllGroups) {
      groupTypes.push(GroupType.IndexManager);
    }
    if (cfg.includeMobileAccess || cfg.includeAllGroups) {
      groupTypes.push(GroupType.MobileAccess);
    }
    if (cfg.includeAdministrativeWorkflow || cfg.includeAllGroups) {
      groupTypes.push(GroupType.AdministrativeWorkflow);
    }
    if (cfg.includeQueryManager || cfg.includeAllGroups) {
      groupTypes.push(GroupType.QueryManager);
    }
    if (cfg.includeGeneralQueryResponder || cfg.includeAllGroups) {
      groupTypes.push(GroupType.GeneralQueryResponder);
    }
    if (cfg.includeISProtectedDocs || cfg.includeAllGroups) {
      groupTypes.push(GroupType.ISProtectedDocs);
    }
    if (cfg.includeISOthers || cfg.includeAllGroups) {
      groupTypes.push(GroupType.ISOthers);
    }
    if (cfg.includeISCRA || cfg.includeAllGroups) {
      groupTypes.push(GroupType.ISCRA);
    }
    if (cfg.includeTIAnalytics || cfg.includeAllGroups) {
      groupTypes.push(GroupType.TIAnalyticsGroup);
    }
    if (cfg.includeOrganizationManagement || cfg.includeAllGroups) {
      groupTypes.push(GroupType.OrganizationManagement);
    }
  }

  return groupTypes;
}
